<template>
    <div class="intro_wrap">
        <div class="intro">
            <page-header class="not_main"></page-header>
            <div class="intro_content">
                <image-component :infoType="'fatherBanner'" class=""></image-component>
                <terms-component :terms-type="`stipulation`"></terms-component>
            </div>
            <page-footer class="not_main"></page-footer>
        </div>
    </div>
</template>

<script>
import ImageComponent from "@/components/information/ImageComponent";
import util from "@/mixins/util";
import TermsComponent from "@/components/terms/TermsComponent";

export default {
    name: "Term",
    mixins: [],
    components: {TermsComponent, ImageComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {


    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {

    },
    watch: {

    },
}
</script>

<style scoped>

</style>
